<section class="switch-container">
  <label class="switch m5">
    <span class="zui-content label-text" [ngClass]="labelPosition"
      *ngIf="label && labelPosition !== 'right'">{{label}}</span>
    <input type="checkbox" [disabled]="disabled" [(ngModel)]="value">
    <small [ngClass]="{'disabled': disabled}"></small>
    <span class="zui-content label-text" *ngIf="label && labelPosition === 'right'">{{label}}</span>
  </label>
</section>